import React, { Component } from 'react';

import Config from './Config';
import './Modal-Structure.css';

const CLOSE_BUTTON_SYMBOL = 'x'

export default class CardModal extends Component {

    createPreyIcon (data, index) {
        let className = 'card-food' + ' ' + 't' + data.trophicLevel
        return (
            <div className={className} key={index}>
                <span>{data.name}</span>
            </div>
        )
    }

    createDietString () {
        let card = this.props.card;
        let dietString = '';

        card.diet.forEach ((diet, index) => {
            dietString += diet.fullName

            if (card.diet [index + 1]) {
                dietString += ', '
            }
        })

        return dietString
    }

    createValidTargetString () {
        let card = this.props.card;
        let dietString = '';

        Config.cards.protectASpecies.validTargets.forEach ((target, index) => {
            dietString += target

            if (Config.cards.protectASpecies.validTargets [index + 1]) {
                dietString += ', '
            }
        })

        return dietString
    }

    getActionDom (isProtectSpeciesCard) {
        let card = this.props.card;
        let title = 'Action Card';
        let type = 'Action'
        let className = 'card-container' + ' ' + card.type.replaceAll (' ', '-').toLowerCase () + ' ' + card.name.toLowerCase ().replaceAll (' ', '-');
        let symbol = card.symbol;

        // if (symbol === '-2') { symbol = 'x' }
        if (symbol === '-2') { symbol = '-2 ice' }
        if (card.name === Config.cards.rapidSeaIceLoss.name) { symbol = '-3 ice' }

        let cardInfoTitle, cardInfoText;

        if (!isProtectSpeciesCard) {
            cardInfoTitle = 'Ice Restored';
            cardInfoText = ' Select one Sea Card to convert to an Ice Card.';
        }
        else {
            cardInfoTitle = 'Species Protection';
            cardInfoText = ' Select one Species Card to Protect from Over Harvesting.';
        }

        let detailsTitle = 'Action Details';
        let detailsText = card.facts;

        let pointsTitle = 'Action Points';
        let pointsText = 'Humans can take helpful actions to protect and conserve the Arctic ecosystem. Each Action card is worth 2 Action Points.'

        if (card.type === Config.types.worldEvent) {
            title = 'Event Card';
            type = 'Event'
            className += ' ' + this.props.img;
            cardInfoTitle = 'Ice Destroyed'
            cardInfoText = ' Select two Ice Cards to convert to Sea Cards by dragging and dropping this card twice.';
            detailsTitle = 'Event Details';
            pointsTitle = 'Event Points';
            pointsText = '';

            if (card.name === Config.cards.carbonPollution.name) {
                pointsText = 'Harmful events such as carbon pollution do not award points and the destruction of ice costs points.'
                className += ' ' + card.img
            }
            else if (card.name === Config.cards.invasiveKillerWhale.name) {
                className += ' s01'
                cardInfoTitle = 'Hunted Animal'
                cardInfoText = 'Select a column of animals to be targeted by invasive killer whales. Species protection does not help against natural events like this one.'
            }
            else if (card.name === Config.cards.oceanAcidification.name) {
                className += ' s02'
                cardInfoTitle = 'Uninhabitable Waters'
                cardInfoText = 'Select a column of animals to be targeted by ocean acidification. Species protection does not help against events like this one.'
            }
            else if (card.name === Config.cards.overHarvesting.name) {
                className += ' s03'
                cardInfoTitle = 'Over Harvested Animal'
                cardInfoText = 'Select a column of animals to be targeted by over-harvesting.'
            }
        }

        let footer = card.footer;

        if (!footer) { footer = type }

        let validTargets = [];

        if (card.validTargets &&
            card.validTargets.length &&
            card.diet &&
            card.diet.length)
        {
            validTargets = card.diet
        }

        let actionValidTargetListText = ''
        if (card.name === Config.cards.protectASpecies.name) {
            actionValidTargetListText = this.createValidTargetString ();
            footer = '';
        }

        let otherTitle = false
        if (card.name !== Config.cards.protectASpecies.name && card.type ===Config.types.action) {
            otherTitle = 'Reduce Carbon Emissions';
            footer = 'Restore 1 Sea Ice';
        }

        let bonusClass = '';
        if (card.name === Config.cards.seaIceRestoration.name) {
            otherTitle = 'Remove Atmospheric Carbon'
            bonusClass = 'sea-ice-restoration-action'
            footer = 'Restore 2 Sea Ice';
        }

        if (footer === 'Event') { footer = '' }

        return (
            <div className="modal action">
                <div className="modal-overlay">
                <section>
                    <header className="modal-header">
                        <h1>{ title }</h1>
                        <button className="close" onClick={this.props.onClick}>{CLOSE_BUTTON_SYMBOL}</button>
                    </header>
                    <div className="modal-content">

                        <div className="card-view">
                            <div className={className}>
                                <section>
                                    <header>
                                        <div className="card-symbol">
                                            <span>{ symbol }</span>
                                        </div>
                                    </header>
                                    <div className="card-title">
                                    {otherTitle &&
                                        <span>{otherTitle}</span>
                                    }
                                        <span>{ card.name }</span>
                                    </div>
                                    <div className="card-image"></div>
                                    { card.type === Config.types.action &&
                                        <div className="">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    }
                                    <footer>
                                    { validTargets.map (this.createPreyIcon) }

                                        { card.type === Config.types.action &&
                                            <div className="card-badge">2 pts</div>
                                        }
                                        <div className="card-type">
                                            <span>{ footer }</span>
                                        </div>
                                    </footer>
                                </section>
                            </div>
                        </div>

                        <div className="card-info">
                            <div id="info-ice">
                                <h2>{ cardInfoTitle }</h2>
                                <p>{ cardInfoText }</p>
                            </div>
                            { actionValidTargetListText.length > 0 &&
                                <div id="info-details">
                                    <h2>{ detailsTitle }</h2>
                                    <p>{ detailsText }</p>
                                    { actionValidTargetListText.length > 0 &&
                                        <p>This can impact the following species: {actionValidTargetListText}</p>
                                    }
                                </div>
                            }
                            { actionValidTargetListText.length === 0 &&
                                <div id="info-details">
                                    <h2>{ detailsTitle }</h2>
                                    <p>{ detailsText }</p>
                                </div>
                            }
                            { actionValidTargetListText.length > 0 &&
                                <div id="info-points" className="contains-target-list">
                                    <h2>{ pointsTitle }</h2>
                                    <p>{ pointsText }</p>
                                </div>
                            }
                            {   actionValidTargetListText.length === 0 &&
                                pointsText.length > 0 &&
                                bonusClass.length === 0 &&
                                    <div id="info-points">
                                        <h2>{ pointsTitle }</h2>
                                        <p>{ pointsText }</p>
                                    </div>
                            }
                            {   actionValidTargetListText.length === 0 &&
                                pointsText.length > 0 &&
                                bonusClass.length > 0 &&
                                    <div id="info-points" className="sea-ice-restoration-action">
                                        <h2>{ pointsTitle }</h2>
                                        <p>{ pointsText }</p>
                                    </div>
                            }
                        </div>
                    </div>

                </section>
                </div>
            </div>
        )
    }

    getSpeciesDom (isPredator) {
        let card = this.props.card;
        let className = 'card-container' + ' ' + card.type.replaceAll (' ', '-').toLowerCase () + ' ' + card.name.toLowerCase ().replaceAll (' ', '-') + ' species';

        if (isPredator) { className += ' pm' }

        let tlOneClassName = 'card-food t1'
        let tlTwoClassName = 'card-food t2'
        let tlThreeClassName = 'card-food t3'
        let tlFourClassName = 'card-food t4'
        let tlFiveClassName = 'card-food t5'

        switch (card.trophicLevel) {
            case 1: tlOneClassName = 'card-food t1 highlight'; break;
            case 2: tlTwoClassName = 'card-food t2 highlight'; break;
            case 3: tlThreeClassName = 'card-food t3 highlight'; break;
            case 4: tlFourClassName = 'card-food t4 highlight'; break;
            case 5: tlFiveClassName = 'card-food t5 highlight'; break;
        }

        let iceRequiredDom = (
            <div id="info-ice">
                <h2>Ice Required</h2>
                <p>This species requires { card.needsIce } ice card{card.needsIce > 1 && (<span>s</span>)} to be played.</p>
            </div>
        )

        if (card.needsIce === 0) {
            iceRequiredDom = (
                <div id="info-ice">
                    <h2>Ice Not Required</h2>
                    <p>This species does not require ice to play.</p>
                </div>
            )
        }

        let modalClassName = 'modal species';

        if (isPredator) { modalClassName += ' pm' }

        let infoDom = (<div id="info-title">
          <h2>Name and Initials</h2>
          <p>{card.symbol} – {card.name}</p>
        </div>)

        let dietString = this.createDietString ()

        let name = card.name;

        if (name === Config.cards.phytoPlankton.name) { name = 'Phyto-plankton' }

        return (
            <div className={modalClassName}>
                <div className="modal-overlay">
                  <section>
                    <header className="modal-header">
                      <h1>Species Card</h1>
                      <button className="close" onClick={this.props.onClick}>{CLOSE_BUTTON_SYMBOL}</button>
                    </header>
                    <div className="modal-content">
                      <div className="card-info">

                    { card.isProtected === true &&
                          <div id="info-protect">
                              <h2>Protection Symbol</h2>
                              <p>This species has been protected.</p>
                          </div>
                    }

                    {isPredator != true &&
                        infoDom
                    }

                        <div id="info-facts">
                          <h2>Species Facts</h2>
                          <p>{ card.facts }</p>
                        </div>

                      </div>
                      <div className="card-view">
                        <div id="" className={className}>
                          <section className="card-wrapper">
                            <header>
                                {card.isProtected === true &&
                                    <div className="card-protection"></div>
                                }

                                {isPredator != true &&
                                    <div className="card-symbol"><span>{card.symbol}</span></div>
                                }
                              { card.needsIce > 0 &&
                                isPredator != true &&
                                  <div className="card-ice-value"><span>{ card.needsIce }</span></div>
                              }
                            </header>
                            <div className="card-title"><span>{ name }</span></div>
                            <div className="card-image"></div>
                            <footer>
                              { card.diet.map (this.createPreyIcon) }
                            </footer>
                          </section>
                        </div>
                      </div>
                      <div className="card-info">

                      {isPredator != true &&
                          iceRequiredDom
                      }

                      {isPredator === true &&
                          infoDom
                      }

                        <div id="info-trophic">
                          <h2>Trophic Level</h2>
                          <div className="trophic-level">
                            <div className={ tlOneClassName }><span>1</span></div>
                            <div className={ tlTwoClassName }><span>2</span></div>
                            <div className={ tlThreeClassName }><span>3</span></div>
                            <div className={ tlFourClassName }><span>4</span></div>
                            <div className={ tlFiveClassName }><span>5</span></div>
                          </div>
                          <p>The trophic level of an organism is the position it occupies in a food web.</p>
                        </div>

                        {dietString.length > 0 &&
                            <div id="info-food">
                                <h2>Food Sources</h2>
                                <p>{ dietString }</p>
                            </div>

                        }
                      </div>
                    </div>
                  </section>
                </div>
              </div>
        )
    }

    getProtectASpeciesDom () {
        let card = this.props.card;
        let title = 'Action Card';
        let type = 'Action'
        let className = 'card-container' + ' ' + card.type.replaceAll (' ', '-').toLowerCase () + ' ' + card.name.toLowerCase ().replaceAll (' ', '-');

        let cardInfoTitle = 'Species Protection';
        let cardInfoText = ' Select one Species Card to Protect from Over Harvesting.';

        let detailsTitle = 'Action Details';
        let detailsText = card.facts;

        let pointsTitle = 'Action Points';
        let pointsText = 'Humans can take helpful actions to protect and conserve the Arctic ecosystem. Each Action card is worth 2 Action Points.'

        let validTargets = [];

        if (card.validTargets &&
            card.validTargets.length &&
            card.diet &&
            card.diet.length)
        {
            validTargets = card.diet
        }

        let footer = '';
        let actionValidTargetListText = ''
        actionValidTargetListText = this.createValidTargetString ();

        return (
            <div className="modal action">
                <div className="modal-overlay">
                <section>
                    <header className="modal-header">
                        <h1>{ title }</h1>
                        <button className="close" onClick={this.props.onClick}>{CLOSE_BUTTON_SYMBOL}</button>
                    </header>
                    <div className="modal-content">

                        <div className="card-info">
                        <div id="info-ice">
                            <h2>{ cardInfoTitle }</h2>
                            <p>{ cardInfoText }</p>
                        </div>
                        { actionValidTargetListText.length > 0 &&
                            <div id="info-details">
                                <h2>{ detailsTitle }</h2>
                                <p>{ detailsText }</p>
                                { actionValidTargetListText.length > 0 &&
                                    <p>This can impact the following species: {actionValidTargetListText}</p>
                                }
                            </div>
                        }
                        { actionValidTargetListText.length === 0 &&
                            <div id="info-details">
                                <h2>{ detailsTitle }</h2>
                                <p>{ detailsText }</p>
                            </div>
                        }

                        </div>

                        <div className="card-view">
                            <div className={className}>
                                <section>
                                    <header>
                                        <div className="card-symbol">
                                            <span>{ card.symbol }</span>
                                        </div>
                                    </header>
                                    <div className="card-title">
                                        <span>{ card.name }</span>
                                    </div>
                                    <div className="card-image"></div>
                                    { card.type === Config.types.action &&
                                        <div className="">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    }
                                    <footer>
                                    { validTargets.map (this.createPreyIcon) }

                                        { card.type === Config.types.action &&
                                            <div className="card-badge">2 pts</div>
                                        }
                                        <div className="card-type">
                                            <span>{ footer }</span>
                                        </div>
                                    </footer>
                                </section>
                            </div>
                        </div>

                        <div className="card-info">
                        { actionValidTargetListText.length > 0 &&
                            <div id="info-points" className="protect-a-species contains-target-list">
                                <h2>{ pointsTitle }</h2>
                                <p>{ pointsText }</p>
                            </div>
                        }
                            {   actionValidTargetListText.length === 0 &&
                                pointsText.length > 0 &&
                                    <div id="info-points">
                                        <h2>{ pointsTitle }</h2>
                                        <p>{ pointsText }</p>
                                    </div>
                            }
                        </div>
                    </div>

                </section>
                </div>
            </div>
        )
    }

    render () {
        let card = this.props.card;
        let dom = (<div></div>);

        if (card && card.type) {
            if (card.name === Config.cards.protectASpecies.name) {
                dom = this.getProtectASpeciesDom ();
            }
            else {
                switch (card.type) {
                    case Config.types.action:
                    case Config.types.worldEvent:
                        dom = this.getActionDom ();
                        break
                    case Config.types.lifeform:
                        dom = this.getSpeciesDom ();
                        break
                    case Config.types.apexPredator:
                        dom = this.getSpeciesDom (true);
                        break
                    default: console.log ('Missing card type. Card:', card)
                }
            }
        }

        return dom
    }
}
